import React from "react";
import Section from "./Section";
import * as content from "../content";

export default function Directions() {
  const { directions: d } = content;
  return (
    <Section id="directions">
      <h2 className="section-title">{d.heading}</h2>
      <p className="prose">{d.intro}</p>
      <ul className="bullet-list">
        {d.bullets.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <div className="map-buttons">
        <a
          className="button button--ghost"
          href={d.maps.google}
          target="_blank"
          rel="noopener noreferrer"
        >
          {d.mapLabels.google}
        </a>
        <a
          className="button button--ghost"
          href={d.maps.apple}
          target="_blank"
          rel="noopener noreferrer"
        >
          {d.mapLabels.apple}
        </a>
      </div>
    </Section>
  );
}
